<template>
    <div class="wx-container wx-container-flex">
        <div class="scroll-container scroll-container-tab">
            <div class="scroll-content" ref="inbox" v-scroll="'inbox'" v-infinite-scroll="more" infinite-scroll-disabled="searching">
                <div
                v-for="(item, index) in list"
                :key="index"
                @click="view(item.id)"
                :class="['message-item card', item.is_read ? 'read' : '',  'box']">
                    <div class="message-item__unread" v-if="!item.is_read"></div>
                    <img src="@/assets/icons/reply-solid.svg"
                    class="message-item__replied"
                    v-if="item.is_reply || item.is_to_me"/>
                    <!-- <div class="message-item__replied {{item.is_to_me ? 'tome' : ''}}"
                    wx:if="{{item.is_reply || item.is_to_me}}">已回复</div> -->
                    <img :src="item.from_user.avatar.src" class="message-item__avatar"/>
                    <div class="message-item-info">
                        <div class="message-item__title">
                            <div class="message-item__username ellipsis">{{item.from_user.username}}</div>
                            <div class="message-item__time">{{item.format_create_time}}</div>
                        </div>
                        <div class="message-item__content ellipsis-line">
                            {{item.is_to_me ? '回复我：' : ''}}{{item.message}}
                        </div>
                    </div>
                </div>
                <div class="empty-notification" v-if="!initializing && !searching && list.length <= 0">
                    <div class="empty-notification__text disable">暂无消息</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const infiniteScroll = window.infiniteScroll
    import token from '@/interface/utils/token'
    import { searchInbox } from '@/interface/modules/message.api'

    export default {
        directives: { infiniteScroll },
        data () {
            return {
                filters: { page: 0 },
                total: 1,
                list: [],
                searching: false,
                initializing: false
            }
        },
        methods: {
            more () {
                const that = this
                if (this.filters.page < this.total) {
                    this.searching = true
                    this.filters.page ++
                    searchInbox({
                        data: this.filters,
                        success: res => {
                            that.searching = false
                            that.list = that.list.concat(res.items)
                            that.total = res.total_page
                        }
                    })
                }
            },
            view (id) {
                this.$router.push({name: 'messageDetail', params: {id: id}})
            }
        },
        activated () {
            const that = this
            const scrollTop = token.getToken('inbox-position')
            if (scrollTop) this.$nextTick(() => {
                that.$refs.inbox.scrollTop = scrollTop
            })
        }
    }
</script>

<style lang="less" scoped>
    .message-title__unread {
        font-size: 10pt;
        color: #08979C;
        font-weight: 400;
    }

    .message-item {
        border-radius: 4px;
        padding: 15px;
        display: flex;
        box-sizing: border-box;
        margin-top: 10px;
        transition: all ease .2s;
        position: relative;
        .message-item__replied {
            position: absolute;
            right: 15px;
            top: 8px;
            width: 12px;
            height: 12px;
        }
        .message-item__unread {
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 100%;
            background-color: #08979C;
            left: 5px;
            top: 32px;
        }
        .message-item__avatar {
            width: 40px;
            height: 40px;
            border-radius: 10px;
        }
        .message-item-info {
            flex: 1;
            padding-left: 15px;
            .message-item__title {
                margin-bottom: 5px;
                margin-top: 5px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .message-item__username {
                flex: 1;
            }
            .message-item__time {
                font-size: 9pt;
                color: #999;
            }
            .message-item__content {
                font-size: 10pt;
                color: #333;
                transition: all ease .2s;
            }
        }
        &.read {
            box-shadow: none;
            background-color: #eee;
            .message-item__content {
                color: #999;
            }
        }
    }
</style>


